export default [
  {
    path: "/login",
    name: "UserLogin",
    meta: { title: "登录" },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/mods/user/login/UserLogin"),
  },
];
